export default __webpack_public_path__ + "static/media/software.58cfd61d.jpg";